// extracted by mini-css-extract-plugin
export default {"formItem":"krJhtJdNmSrv4jPsF5Ys"};